import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import SecondNav from "../SecondNav";
import Notification from "../Notification";
import Icon from "../Icon";
import Upload from "./upload.js";
import Property from "./propertiesTab.js";
import Orgs from "./orgsTab.js";
import FloorPlan from "./floorPlan.js";
import Wait from "./wait";

const DialogTitle = withStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: "0px !important",
    background: "#FFF"
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500]
  }
}))(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <Icon type="icon-e-remove" size="md" />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing.unit * 2,
    background: "#FFF"
  }
}))(MuiDialogContent);

class ImageDialog extends React.Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
  }

  handleReferenceMethod = () => {
    this.child.current.handleReferenceMethod();
  };

  render() {
    const {
      handleClose,
      tabs,
      open,
      notification,
      notificationId,
      notificationType,
      notificationBody,
      notificationPermanent,
      environment,
      propertyId,
      handleGalleryImage,
      selectedTab,
      handleTab,
      loading
    } = this.props;
    return (
      <div>
        <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          fullScreen={true}
        >
          <DialogTitle id="customized-dialog-title" onClose={handleClose}>
            <SecondNav
              type="tabs-buttons"
              tabs={tabs}
              block_tabs={false}
              action_icons={[
                {
                  type: "icon-e-remove",
                  name: "Close",
                  xs_visible: false,
                  onClick: handleClose
                }
              ]}
              selected_tab={selectedTab}
              handleChange={handleTab}
              swipeableViewsStyles={{
                overflowX: "hidden",
                overflowY: "hidden",
                position: "fixed",
                width: "100%"
              }}
            >
              {[
                <Grid container key={1} className="first-tab">
                  {this.props.dimension_width && this.props.dimension_height ? (
                    <Upload ref={this.child} {...this.props} />
                  ) : (
                      <Wait />
                    )}
                </Grid>,
                <Grid
                  container
                  key={2}
                  style={{ position: "relative", overflow: "hidden" }}
                >
                  {this.props.dimension_width && this.props.dimension_height ? (
                    <Property
                      environment={environment}
                      propertyId={propertyId}
                      handleGalleryImage={handleGalleryImage}
                      loading={loading}
                    />
                  ) : (
                      <Wait />
                    )}
                </Grid>,

                <Grid
                  container
                  key={3}
                  style={{ position: "relative", overflow: "hidden" }}
                >
                  {this.props.dimension_width && this.props.dimension_height ? (
                    <Orgs
                      environment={environment}
                      propertyId={propertyId}
                      handleGalleryImage={handleGalleryImage}
                      loading={loading}
                    />
                  ) : (
                      <Wait />
                    )}
                </Grid>,

                <Grid
                  container
                  key={3}
                  style={{ position: "relative", overflow: "hidden" }}
                >
                  {this.props.dimension_width && this.props.dimension_height ? (
                    <FloorPlan
                      environment={environment}
                      propertyId={propertyId}
                      handleGalleryImage={handleGalleryImage}
                      loading={loading}
                    />
                  ) : (
                      <Wait />
                    )}
                </Grid>
              ]}
            </SecondNav>
          </DialogTitle>

          {notification ? (
            <Notification
              notifications={[
                {
                  id: notificationId.toString(),
                  type: notificationType,
                  body: notificationBody,
                  permanent: notificationPermanent
                }
              ]}
            />
          ) : null}
          <DialogContent />
        </Dialog>
      </div>
    );
  }
}

export default ImageDialog;
